// 必须使用完整的URL,否则会导致iphone进行拦截
let loginUrl = 'https://t.tantu.com/account/login2.php';
// tantu
let tantutravelHost = '//m.tantu.com';

if (process.env.NODE_ENV === 'development') {
  loginUrl = 'https://t-dev.tantu.com/account/login2.php';
  tantutravelHost = '//m-dev.tantu.com';
}

if(window.location.origin.indexOf('t-dev.tantu.com') > -1){
  tantutravelHost = '//m-dev.tantu.com';
  loginUrl = 'https://t-dev.tantu.com/account/login2.php';
}

module.exports = {
  downloadTanTuTravel: 'https://m.tantu.com/app/tantutravel/index.php',
  downloadTanTuMap: 'https://www.tantu.com/app/tantumap/',
  downloadZuzuche: 'https://m.zuzuche.com/app_download.php',
  loginUrl: loginUrl,
  tantutravelHost,
  hotelImage: '//imgcdn1.zuzuche.com/m_tantu_image/20170330/a94e03d3a02a298b3c43acef9ae8571f.png'
};



// WEBPACK FOOTER //
// ./src/config.js